import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { PageNames, ROUTE_HIERARCHY } from '../Constants.ts';

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const paths = location.pathname.split('/').filter(Boolean);


  console.log('Current path:', location.pathname);
  console.log('Path segments:', paths);
  console.log('ROUTE_HIERARCHY:', ROUTE_HIERARCHY);

  function toSentenceCase(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const generateBreadcrumbs = () => {
    let currentLevel: any = ROUTE_HIERARCHY;
    const breadcrumbs: any[] = [];
    let accumulatedPath = '';

    // Always start with home
    breadcrumbs.push({
      title: currentLevel.title || 'Home',
      path: currentLevel.path || '/',
    });

    for (const segment of paths) {
      accumulatedPath += `/${segment}`;

      if (currentLevel.children && currentLevel.children[segment]) {
        currentLevel = currentLevel.children[segment];
        breadcrumbs.push({
          title: currentLevel.title || segment,
          path: accumulatedPath,
        });
      } else {
        // Fallback for unknown segments
        breadcrumbs.push({
          title: segment,
          path: accumulatedPath,
        });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-container">
      <ol className="breadcrumb">
        {breadcrumbs.map((crumb, index) => (
          <li
            key={index}
            className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`}
            aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}
          >
            {index === breadcrumbs.length - 1 ? (
              PageNames(toSentenceCase(crumb.title))
            ) : (
              <Link to={crumb.path}>{PageNames(toSentenceCase(crumb.title))}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;